'use strict';
/*
* Product images slider
* @package krobot
* @deps swiper
*/

var productSwiper = new Swiper ('.js-product-slider', { // eslint-disable-line
	//slidesPerView: 1,
	pagination: {
		el: '.product-info__slider-pagination',
		type: 'bullets',
		clickable: true,
	},
	navigation: {
		nextEl: '.product-info__slider-button-next',
		prevEl: '.product-info__slider-button-prev',
	},
} );
